import { jsx as _jsx } from "react/jsx-runtime";
import CustomTheme from '../../../styles/theme';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import './custom-modal-residencia-fiscal.scss';
import { ThemeProvider } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import useTheme from '@mui/material/styles/useTheme';
const CustomModalResidencia = ({ children, isOpen, handleClose, className, canBeClose }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery('(max-width: 600px)');
    const closeModal = () => {
        if (canBeClose) {
            handleClose(false);
        }
    };
    return (_jsx(Modal, { open: isOpen, onClose: closeModal, "aria-labelledby": "custom-modal-occupation-title", "aria-describedby": "custom-modal-occupation-description", className: 'custom-modal-occupation', children: _jsx(ThemeProvider, { theme: CustomTheme, children: _jsx(Box, { className: `custom-modal-component-residencia ${className ?? ''}`, sx: {
                    backgroundColor: '#FFFFFF',
                    color: '#434A54',
                    position: 'fixed',
                    left: isMobile ? 0 : '50%',
                    boxSizing: 'border-box',
                    width: '100%',
                    borderTopRightRadius: '24px',
                    borderTopLeftRadius: '24px',
                    [theme.breakpoints.up(600)]: {
                        borderRadius: '24px',
                        left: '50%',
                        top: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 'auto',
                    },
                    '&.show': {
                        transform: 'translateY(0)',
                    },
                }, children: _jsx(Box, { className: 'custom-modal-component-residencia_child', sx: {
                        padding: isMobile ? '24px' : '32px',
                    }, children: children }) }) }) }));
};
export default CustomModalResidencia;
